const Empty = () => (window.location.href = "https://localhost:8083/examples/#V2019-EDITORIALS");

export default Empty;
